import * as React from "react";
import Tooltip from "@8x8/oxygen-tooltip";

const ValidationWrapper = React.memo(({ errors, children, ...rest }) => {
  const [parentRef, setParentRef] = React.useState(null);

  return (
    <div ref={setParentRef} {...rest}>
      {children}
      {errors?.length > 0 && (
        <Tooltip
          title={errors.join(", ")}
          includeWrapper={false}
          triggerRef={parentRef}
        />
      )}
    </div>
  );
});

export default ValidationWrapper;
